export namespace Tariff {
	export type ShortTariffInfo = Pick<TariffWithSettings, 'id' | 'name' | 'applyOnRequest'>;

	export type TariffsInfoResponse = {
		tariffs: TariffWithSettings[];
		tariffsInfo: TariffInfo[];
	};

	export enum TariffName {
		Basic = 'Basic',
		Silver = 'Silver',
		Gold = 'Gold',
		PlatinumDiamond = 'Platinum / Diamond',
	}

	export type TariffWithSettings = {
		id: TariffId;
		description: string;
		bestChoice: boolean;
		name: TariffName;
		priceDescription: string;
		prompt: string;
		order: number;
		applyOnRequest: boolean;
		settings: Setting[];
		defaultDurationInMonths: number;
		buttonName?: string;
	};

	export type Setting = {
		infoId: TariffInfo['id'];
		value: string | boolean;
		description: string;
	};

	export type TariffInfo = {
		id: string;
		name: string;
		prompt: string;
		order: number;
		description: string;
	};

	export enum TariffId {
		Maximal = 1,
		Standart = 2,
		Econom = 3,
		Silver = 4,
		Gold = 5,
		PlatinumDiamond = 6,
		Basic = 7,
		GoldPromo = 10,
	}
}
